import lscache from 'lscache';
import Logger from 'utils/Logger';

const MONTH = 60 * 24 * 30;

export interface ActionFactory {
  setCurrency: (currency: string) => void;
}

function actionsFactory(dispatcher): ActionFactory {
  return {
    setCurrency(newCurrency) {
      dispatcher({ payload: { currency: newCurrency } });
      Logger.log('settings currency to ' + newCurrency);
      lscache.set('CURRENCY', newCurrency, MONTH);
    },
  };
}

export default actionsFactory;
